export function changeIndexArray(arr: any[], fromIndex: number, toIndex: number): any[] {
    var newArr = arr;
    var element = newArr[fromIndex];

    newArr.splice(fromIndex, 1);
    newArr.splice(toIndex, 0, element);

    return newArr;
}
